import apiService from '../../../services/api-client';
import { PriceSuggestionResponse } from '../interfaces/price-suggestion';

export const priceSuggestionApiService = {
    async getSuggestedPrice(companyId: number, productName: string): Promise<PriceSuggestionResponse> {
        console.log('Llamando API con:', { companyId, productName });

        const { data } = await apiService().get<any>(
            `company/${companyId}/product/suggestPrice?productName=${encodeURIComponent(productName)}`
        );

        console.log('Respuesta raw de la API:', data);

        // Intentar mapear diferentes formatos de respuesta que podría devolver la API
        let suggestedPrice: number;

        if (typeof data === 'number') {
            suggestedPrice = data;
        } else if (data && typeof data.suggested_price === 'number') {
            // La API devuelve en snake_case
            suggestedPrice = data.suggested_price;
        } else if (data && typeof data.suggestedPrice === 'number') {
            // Por si acaso devuelve en camelCase
            suggestedPrice = data.suggestedPrice;
        } else if (data && typeof data.price === 'number') {
            suggestedPrice = data.price;
        } else if (data && typeof data.amount === 'number') {
            suggestedPrice = data.amount;
        } else if (data && typeof data.value === 'number') {
            suggestedPrice = data.value;
        } else {
            console.error('Formato de respuesta no reconocido:', data);
            throw new Error(`Formato de respuesta inválido: ${JSON.stringify(data)}`);
        }

        console.log('Precio procesado:', suggestedPrice);

        return { suggestedPrice };
    },
}; 